(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}
	 	connectedCallback() {
			this.header = document.querySelector('.section-header');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
	
			this.setHeaderHeight();
	
			window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
	
			if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky');
			};
	
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');
	
			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);
	
			this.createObserver();
		}
		setHeaderHeight() {
			document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
		}
		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}
		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});
			observer.observe(this.header);
		}
	  	onScroll() {
			if (document.documentElement.classList.contains('hd-menu-open')) return;   // menu burger terbuka: header tetap terlihat
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
	
			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				this.header.classList.add('scrolled-past-header');
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				this.header.classList.add('scrolled-past-header');
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerBounds.top) {
				this.header.classList.remove('scrolled-past-header');
				requestAnimationFrame(this.reset.bind(this));
			}
	
			this.currentScrollTop = scrollTop;
	  	}
  
		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		}
		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
	
		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}
	}
	// Menu burger (mobile): buka/tutup panel
	(function () {
		var root = document.documentElement;
		function panel() { return document.querySelector('.hd-mnav'); }
		function isOpen() { var p = panel(); return !!(p && p.classList.contains('is-open')); }

		function setMenu(open) {
			var p = panel();
			if (!p) return;
			if (open) {
				// Header jangan sampai ikut tersembunyi (efek sticky) selama menu terbuka
				var sh = document.querySelector('.section-header');
				if (sh) sh.classList.remove('shopify-section-header-hidden');
				// Panel mulai tepat di bawah header
				var h = document.querySelector('.header .vela-section') || document.querySelector('.header__inner');
				if (h) p.style.setProperty('--hd-panel-top', Math.max(0, h.getBoundingClientRect().bottom) + 'px');
			}
			root.classList.toggle('hd-menu-open', open);
			p.classList.toggle('is-open', open);
			if (open) { setTimeout(periksaPenghalang, 400); } else { pulihkan(); setTimeout(periksaSetelahTutup, 450); }
			document.querySelectorAll('.hd-burger').forEach(function (b) {
				b.classList.toggle('is-open', open);
				b.setAttribute('aria-expanded', open ? 'true' : 'false');
			});
		}
		// Pengaman: kalau ada elemen lain (lapisan transparan dari widget/tema) menutupi panel sehingga ketukan tidak sampai,
		// elemen itu dicatat di Console dan sementara dibuat "tembus klik" selama menu terbuka.
		var dimatikan = [];
		function pulihkan() {
			dimatikan.forEach(function (el) { el.style.removeProperty('pointer-events'); });
			dimatikan = [];
		}
		function periksaPenghalang() {
			var p = panel();
			if (!p || !p.classList.contains('is-open')) return;
			var titik = [
				[window.innerWidth * 0.5, p.getBoundingClientRect().top + 60],
				[window.innerWidth * 0.5, p.getBoundingClientRect().top + 140],
				[window.innerWidth * 0.5, window.innerHeight * 0.6]
			];
			titik.forEach(function (t) {
				var el = document.elementFromPoint(t[0], t[1]);
				if (!el || p.contains(el) || el.closest('.hd-burger')) return;
				var r = el.getBoundingClientRect();
				var besar = r.width >= window.innerWidth * 0.8 && r.height >= window.innerHeight * 0.3;
				console.warn('[hd-mnav] Panel menu tertutup elemen lain:', el, besar ? '(dibuat tembus klik)' : '');
				if (besar) { el.style.setProperty('pointer-events', 'none', 'important'); dimatikan.push(el); }
			});
		}
		// Setelah menu ditutup: pastikan halaman benar-benar bisa diklik lagi.
		// Kalau ada lapisan besar (fixed/absolute) yang masih menutupi layar, dicatat di Console lalu dibuat tembus klik.
		function periksaSetelahTutup() {
			if (isOpen()) return;
			[document.documentElement, document.body].forEach(function (el) {
				if (getComputedStyle(el).pointerEvents === 'none') el.style.setProperty('pointer-events', 'auto', 'important');
			});
			[[0.5, 0.3], [0.5, 0.5], [0.5, 0.75], [0.2, 0.5], [0.8, 0.5]].forEach(function (t) {
				var el = document.elementFromPoint(window.innerWidth * t[0], window.innerHeight * t[1]);
				if (!el || el === document.documentElement || el === document.body) return;
				var cs = getComputedStyle(el);
				var r = el.getBoundingClientRect();
				var menutupi = (cs.position === 'fixed' || cs.position === 'absolute') && cs.zIndex !== 'auto' &&
					r.width >= window.innerWidth * 0.8 && r.height >= window.innerHeight * 0.3 &&
					!el.matches('main, header, footer, section, nav, article, sticky-header, .hd-burger');
				if (menutupi) {
					console.warn('[hd-mnav] Lapisan masih menutupi halaman setelah menu ditutup:', el, '(dibuat tembus klik)');
					el.style.setProperty('pointer-events', 'none', 'important');
					dimatikan.push(el);
				}
			});
		}
		function toggleBurger() { setMenu(!isOpen()); }

		// Satu pendengar klik di level dokumen (fase capture): tetap jalan walau tombol dirender ulang,
		// dan tidak bisa "dicegat" script lain yang ikut mendengarkan klik di header.
		document.addEventListener('click', function (e) {
			var b = e.target.closest ? e.target.closest('.hd-burger') : null;
			if (!b) return;
			e.preventDefault();
			e.stopPropagation();
			toggleBurger();
		}, true);

		// Event listener akordion menu
		document.addEventListener('click', function (e) {
			var head = e.target.closest('.hd-mnav__head');
			if (head) {
				if (head.classList.contains('hd-mnav__plain')) return;
				var group = head.parentNode;
				var sedangTerbuka = group.classList.contains('is-open');
				document.querySelectorAll('.hd-mnav__group').forEach(function (g) {
					g.classList.remove('is-open');
					var hEl = g.querySelector('.hd-mnav__head');
					if (hEl) hEl.setAttribute('aria-expanded', 'false');
				});
				if (!sedangTerbuka) {
					group.classList.add('is-open');
					head.setAttribute('aria-expanded', 'true');
				}
			}
		});

		// Tombol masuk/daftar di panel menu: tutup menu dulu supaya popup tidak tertimpa panel, lalu buka popup yang sama dengan tombol di header desktop
		document.addEventListener('click', function (e) {
			var c = e.target.closest ? e.target.closest('.hd-mnav__cta') : null;
			if (!c) return;
			e.preventDefault();
			setMenu(false);
			setTimeout(function () {
				if (typeof window.showPopupRegister === 'function') window.showPopupRegister();
			}, 200);
		});

		document.addEventListener('keydown', function (e) { 
			if (e.key === 'Escape') {
				var p = panel();
				if (p && p.classList.contains('is-open')) setMenu(false);
			}
		});

		window.matchMedia('(min-width: 992px)').addEventListener('change', function (e) { 
			if (e.matches) {
				var p = panel();
				if (p && p.classList.contains('is-open')) setMenu(false);
			}
		});

	})();

	// Dropdown baris menu: hover (desktop), klik (layar sentuh), Esc untuk menutup
	(function () {
		var hoverOk = window.matchMedia('(hover: hover)').matches;
		function semua() { return document.querySelectorAll('.hd-nav__item'); }
		function setOpen(item, open) {
			item.classList.toggle('is-open', open);
			var btn = item.querySelector('.hd-nav__btn');
			if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
		}
		function tutupSemua(kecuali) {
			semua().forEach(function (i) { if (i !== kecuali) setOpen(i, false); });
		}
		document.addEventListener('click', function (e) {
			var btn = e.target.closest('.hd-nav__btn');
			if (!btn) { tutupSemua(); return; }
			var item = btn.parentNode;
			var sedangTerbuka = item.classList.contains('is-open');
			var adalahLink = btn.tagName === 'A' && btn.getAttribute('href') && btn.getAttribute('href') !== '#';
			if (adalahLink && btn.classList.contains('hd-nav__parent')) {
				// Mouse: klik langsung pindah halaman (dropdown sudah terbuka lewat hover).
				// Layar sentuh: ketukan pertama membuka dropdown, ketukan kedua pindah halaman.
				if (!hoverOk && !sedangTerbuka) { e.preventDefault(); tutupSemua(item); setOpen(item, true); }
				return;
			}
			tutupSemua(item);
			setOpen(item, hoverOk ? true : !sedangTerbuka);
		});
		document.addEventListener('mouseover', function (e) {
			if (!hoverOk) return;
			var item = e.target.closest('.hd-nav__item');
			if (item) { tutupSemua(item); setOpen(item, true); }
		});
		document.addEventListener('mouseout', function (e) {
			if (!hoverOk) return;
			var item = e.target.closest('.hd-nav__item');
			if (item && !item.contains(e.relatedTarget)) setOpen(item, false);
		});
		document.addEventListener('keydown', function (e) { if (e.key === 'Escape') tutupSemua(); });
		document.addEventListener('focusin', function (e) { if (!e.target.closest('.hd-nav__item')) tutupSemua(); });
	})();
	// Header mengecil saat di-scroll (desktop). Dua ambang supaya tidak berkedip di batas.
	(function () {
		var wrap = null, ticking = false, desktop = window.matchMedia('(min-width: 992px)');
		function update() {
			ticking = false;
			wrap = wrap || document.querySelector('.header-wrapper');
			if (!wrap) return;
			var y = window.pageYOffset || document.documentElement.scrollTop;
			var on = wrap.classList.contains('hd-condensed');
			if (!desktop.matches) { if (on) wrap.classList.remove('hd-condensed'); return; }
			if (!on && y > 120) wrap.classList.add('hd-condensed');
			else if (on && y < 40) wrap.classList.remove('hd-condensed');
			if (wrap.classList.contains('hd-condensed')) layoutNav();
		}
		// Hitung ruang kosong di antara logo dan ikon search, lalu menu ditaruh di situ
		function layoutNav() {
			var nav = wrap.querySelector('.header__navbar');
			var sec = wrap.querySelector('.vela-section[data-section-type="header-section"]');
			var logo = wrap.querySelector('.header-left');
			var right = wrap.querySelector('.header-right');
			if (!nav || !sec || !logo || !right) return;
			var kiri = logo.getBoundingClientRect().left + 120 + 24;     // logo mengecil jadi 120px
			var kanan = right.getBoundingClientRect().left - 55 - 16;    // sisakan tempat ikon search (40px)
			nav.style.setProperty('--hd-nav-l', Math.max(0, kiri - sec.getBoundingClientRect().left) + 'px');
			nav.style.setProperty('--hd-nav-w', Math.max(200, kanan - kiri) + 'px');
		}
		window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } });
		window.addEventListener('scroll', function () {
			if (!ticking) { ticking = true; requestAnimationFrame(update); }
		}, { passive: true });
		desktop.addEventListener('change', update);
		document.addEventListener('DOMContentLoaded', update);
		update();
	})();
	// Pencarian di header: saran produk langsung di bawah kolom ketik
	(function () {
		var box = document.querySelector('.hd-search');
		if (!box) return;
		var form = box.querySelector('.hd-search__form');
		var input = box.querySelector('.hd-search__input');
		var panel = box.querySelector('.hd-sugg');
		var list = box.querySelector('.hd-sugg__list');
		var empty = box.querySelector('.hd-sugg__empty');
		var all = box.querySelector('.hd-sugg__all');
		var apiUrl = box.getAttribute('data-url') || '/search/suggest';
		var currency = box.getAttribute('data-currency') || 'IDR';
		var locale = (box.getAttribute('data-locale') || 'id').replace('_', '-');
		var timer = null, ctrl = null, lastQ = '', bukaDi = 0, posisiBuka = 0;

		function wrap() { return document.querySelector('.header-wrapper'); }
		function condensed() { var w = wrap(); return w && w.classList.contains('hd-condensed'); }

		function rupiah(v) {
			var n = parseFloat(v);
			if (isNaN(n)) return '';
			try {
				var f = new Intl.NumberFormat(locale === 'id' ? 'id-ID' : locale, { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
				return f.format(n).replace(/\u00a0/g, ' ');
			} catch (e) { return n.toLocaleString('id-ID'); }
		}
		function gambar(p) {
			var u = (p.featured_image && p.featured_image.url) || p.image || '';
			if (!u) return '';
			return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
		}

		function tutup() {
			panel.hidden = true;
			box.classList.remove('has-sugg');
			input.setAttribute('aria-expanded', 'false');
		}
		function buka() {
			bukaDi = Date.now();
			posisiBuka = window.pageYOffset || document.documentElement.scrollTop;
			panel.hidden = false;
			box.classList.add('has-sugg');
			input.setAttribute('aria-expanded', 'true');
		}

		function tampil(produk, q) {
			list.innerHTML = '';
			produk.forEach(function (p) {
				var li = document.createElement('li');
				var a = document.createElement('a');
				a.className = 'hd-sugg__item';
				a.href = p.url;
				a.setAttribute('role', 'option');
				var im = document.createElement('span'); im.className = 'hd-sugg__img';
				var src = gambar(p);
				if (src) { var img = document.createElement('img'); img.src = src; img.alt = ''; img.loading = 'lazy'; img.width = 52; img.height = 52; im.appendChild(img); }
				var tx = document.createElement('span'); tx.className = 'hd-sugg__txt';
				var nm = document.createElement('span'); nm.className = 'hd-sugg__name'; nm.textContent = p.title;
				var pr = document.createElement('span'); pr.className = 'hd-sugg__price'; pr.textContent = rupiah(p.price);
				tx.appendChild(nm); tx.appendChild(pr);
				a.appendChild(im); a.appendChild(tx);
				li.appendChild(a); list.appendChild(li);
			});
			empty.hidden = produk.length > 0;
			all.hidden = produk.length === 0;
			all.href = form.action + '?q=' + encodeURIComponent(q);
			buka();
		}

		function cari(q) {
			if (ctrl) ctrl.abort();
			ctrl = window.AbortController ? new AbortController() : null;
			var url = apiUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=2&resources[options][unavailable_products]=last';
			fetch(url, ctrl ? { signal: ctrl.signal } : {})
				.then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
				.then(function (d) {
					if (input.value.trim() !== q) return;   // sudah berubah, abaikan hasil lama
					var produk = (d.resources && d.resources.results && d.resources.results.products) || [];
					tampil(produk, q);
				})
				.catch(function (e) { if (e && e.name === 'AbortError') return; tutup(); });
		}

		input.addEventListener('input', function () {
			var q = input.value.trim();
			clearTimeout(timer);
			if (q.length < 2) { lastQ = ''; tutup(); return; }
			if (q === lastQ) return;
			lastQ = q;
			timer = setTimeout(function () { cari(q); }, 250);
		});
		input.addEventListener('focus', function () {
			if (list.children.length || !empty.hidden) { if (input.value.trim().length >= 2) buka(); }
		});

		// Header mengecil: klik ikon pertama kali = melebarkan kolom ketik, bukan mengirim form
		form.addEventListener('submit', function (e) {
			if (condensed() && !box.classList.contains('is-open')) {
				e.preventDefault();
				box.classList.add('is-open');
				bukaDi = Date.now();
				posisiBuka = window.pageYOffset || document.documentElement.scrollTop;
				setTimeout(function () { input.focus(); }, 300);
				return;
			}
			if (input.value.trim() === '') e.preventDefault();
		});

		function tutupSemua() {
			tutup();
			if (condensed()) box.classList.remove('is-open');
		}
		document.addEventListener('click', function (e) { if (!e.target.closest('.hd-search')) tutupSemua(); });
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') { tutupSemua(); }
			if (e.key === 'ArrowDown' && document.activeElement === input) {
				var first = list.querySelector('a'); if (first && !panel.hidden) { e.preventDefault(); first.focus(); }
			}
		});
		panel.addEventListener('keydown', function (e) {
			var links = Array.prototype.slice.call(panel.querySelectorAll('a'));
			var i = links.indexOf(document.activeElement);
			if (i < 0) return;
			if (e.key === 'ArrowDown') { e.preventDefault(); (links[i + 1] || links[i]).focus(); }
			if (e.key === 'ArrowUp') { e.preventDefault(); if (i === 0) input.focus(); else links[i - 1].focus(); }
		});
		// Ada pergerakan (scroll) lagi: kolom search menutup kembali jadi ikon, saran produk ikut tertutup
		window.addEventListener('scroll', function () {
			var terbuka = box.classList.contains('is-open') || !panel.hidden;
			if (!terbuka) return;
			if (Date.now() - bukaDi < 500) return;   // abaikan geseran kecil akibat fokus/animasi saat baru dibuka
			var y = window.pageYOffset || document.documentElement.scrollTop;
			if (Math.abs(y - posisiBuka) < 8 && box.classList.contains('is-open')) return;
			tutupSemua();
			if (document.activeElement === input) input.blur();
			posisiBuka = y;
		}, { passive: true });

		// Header kembali besar: lepas status "terbuka" supaya tampilan normal
		new MutationObserver(function () { if (!condensed() && box.classList.contains('is-open')) box.classList.remove('is-open'); })
			.observe(document.querySelector('.header-wrapper') || document.body, { attributes: true, attributeFilter: ['class'] });
	})();
	// Saran produk di burger menu (mobile)
	(function () {
		var panel = document.querySelector('.hd-mnav');
		if (!panel) return;
		var form = panel.querySelector('.hd-mnav__search');
		var input = form && form.querySelector('input[name="q"]');
		var box = panel.querySelector('.hd-mnav__sugg');
		if (!input || !box) return;
		var list = box.querySelector('.hd-sugg__list');
		var empty = box.querySelector('.hd-sugg__empty');
		var all = box.querySelector('.hd-sugg__all');
		var apiUrl = panel.getAttribute('data-url') || '/search/suggest';
		var currency = panel.getAttribute('data-currency') || 'IDR';
		var locale = (panel.getAttribute('data-locale') || 'id').replace('_', '-');
		var timer = null, ctrl = null, lastQ = '';

		function rupiah(v) {
			var n = parseFloat(v);
			if (isNaN(n)) return '';
			try {
				return new Intl.NumberFormat(locale === 'id' ? 'id-ID' : locale, { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n).replace(/\u00a0/g, ' ');
			} catch (e) { return n.toLocaleString('id-ID'); }
		}
		function gambar(p) {
			var u = (p.featured_image && p.featured_image.url) || p.image || '';
			return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
		}
		function tutup() {
			// Hanya ubah kalau memang perlu. classList.remove() pada kelas yang tidak ada pun tetap dianggap
			// "perubahan" oleh MutationObserver, dan itu membuat perulangan tanpa henti (halaman membeku).
			if (!box.hidden) box.hidden = true;
			if (panel.classList.contains('has-sugg')) panel.classList.remove('has-sugg');
		}
		function tampil(produk, q) {
			list.innerHTML = '';
			produk.forEach(function (p) {
				var li = document.createElement('li');
				var a = document.createElement('a');
				a.className = 'hd-sugg__item'; a.href = p.url;
				var im = document.createElement('span'); im.className = 'hd-sugg__img';
				var src = gambar(p);
				if (src) { var img = document.createElement('img'); img.src = src; img.alt = ''; img.loading = 'lazy'; img.width = 52; img.height = 52; im.appendChild(img); }
				var tx = document.createElement('span'); tx.className = 'hd-sugg__txt';
				var nm = document.createElement('span'); nm.className = 'hd-sugg__name'; nm.textContent = p.title;
				var pr = document.createElement('span'); pr.className = 'hd-sugg__price'; pr.textContent = rupiah(p.price);
				tx.appendChild(nm); tx.appendChild(pr); a.appendChild(im); a.appendChild(tx);
				li.appendChild(a); list.appendChild(li);
			});
			empty.hidden = produk.length > 0;
			all.hidden = produk.length === 0;
			all.href = form.action + '?q=' + encodeURIComponent(q);
			box.hidden = false;
			panel.classList.add('has-sugg');
		}
		function cari(q) {
			if (ctrl) ctrl.abort();
			ctrl = window.AbortController ? new AbortController() : null;
			fetch(apiUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=2&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
				.then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
				.then(function (d) {
					if (input.value.trim() !== q) return;
					tampil((d.resources && d.resources.results && d.resources.results.products) || [], q);
				})
				.catch(function (e) { if (!e || e.name !== 'AbortError') tutup(); });
		}
		input.addEventListener('input', function () {
			var q = input.value.trim();
			clearTimeout(timer);
			if (q.length < 2) { lastQ = ''; tutup(); return; }
			if (q === lastQ) return;
			lastQ = q;
			timer = setTimeout(function () { cari(q); }, 250);
		});
		// Burger ditutup: kembalikan tampilan awal (menu terlihat, hasil hilang)
		new MutationObserver(function () { if (!panel.classList.contains('is-open') && (!box.hidden || panel.classList.contains('has-sugg'))) tutup(); })
			.observe(panel, { attributes: true, attributeFilter: ['class'] });
	})();
	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-simple"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-style1"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
        }
    }
    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
		super();
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);
			fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');
				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
					initButtons();
					vela.swatchProduct();
					if (window.SPR && vela.settings.enableReview) {
						return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();				
					}
				}
			})
			.catch(e => {
				console.error(e);
			});
		}
	
		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}
	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
